<template>
  <div class="mr-3">
    <b-dropdown
      class="w-100 btn-overflow"
      variant="outline-secondary"
      size="sm"
      :text="name"
    >
      <b-form-group>
        <b-form-checkbox        
          v-model="allSelected"
          :aria-describedby="name"
          :aria-controls="name"
          class="dropdownclass"
          @change="toggleAll"
        >
          <span class="aligntextmiddle">
            {{ allSelected ? "Unselect all" : "Choose all" }}
          </span>
        </b-form-checkbox>
        <b-form-checkbox-group
          :id="name"
          v-model="categoryIds"
          :name="name"
          class="dropdownclass"
          :aria-label="'Individual ' + name"
          stacked
        >
          <b-form-checkbox
            v-for="option in formField.options"
            :key="option.value"
            :value="option.value"
          >
            <span class="aligntextmiddle">{{ option.text }}</span>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "CheckboxDropdownCategories",
  props: {
    name: String,
    formField: Object
  },
  computed: {
    categoryIds: {
      get() {
        return this.$store.getters['searchApiBody/getPayload']['category_id']
      },
      set(value) {
        this.$store.commit('searchApiBody/updateCategoryIds', value);
      },
  }
},
  data() {
    return {
      allSelected: false
    };
  },
  methods: {
    toggleAll(checked) {
      this.$store.commit('searchApiBody/updateCategoryIds', checked ? this.formField.options.map(a => a.value) : []);
    }
  }
};
</script>
<style scoped>
.dropdown {
  min-width: 7rem;
}
.dropdownclass{
  font-size: 0.65em;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.aligntextmiddle{
  color: #495057;
  vertical-align: sub;
  font-size: 1.05em;
}
>>> .dropdown-toggle {
  color: black;
  border-color: rgb(159 157 156 / var(--tw-border-opacity));
  --tw-border-opacity: 1;
  --tw-bg-opacity: 1;
  box-shadow: none;
  outline: none;
}
>>> .dropdown-toggle:hover,
>>> .dropdown-toggle:active,
>>> .dropdown-toggle:focus-visible,
>>> .show > .dropdown-toggle {
  background-color: rgb(139 201 255 / var(--tw-bg-opacity)) !important;
  border-color: rgb(0 147 255 / var(--tw-border-opacity)) !important;
  color: black !important;
}
>>> .groupresultclass {
  font-size: small;
  color: #dc3545;
}
>>> .dropdownclass div {
  display: table-caption;
}
</style>
